var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWeChatPay = function SvgWeChatPay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#weChatPay_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 20,
    fill: "#fff",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#09BB07",
    d: "M13.985 11.695a.5.5 0 0 1-.222.05.49.49 0 0 1-.43-.253l-.034-.067-1.355-2.912c-.017-.035-.017-.067-.017-.102 0-.136.103-.237.24-.237q.078 0 .155.05l1.595 1.118c.12.067.257.118.411.118q.13 0 .257-.05l7.48-3.284c-1.338-1.558-3.55-2.574-6.055-2.574-4.083 0-7.41 2.726-7.41 6.093 0 1.827.994 3.486 2.555 4.604.12.085.205.237.205.389 0 .05-.016.101-.034.152-.12.457-.327 1.203-.327 1.235a.6.6 0 0 0-.035.187c0 .136.103.237.24.237a.2.2 0 0 0 .138-.05l1.612-.932a.8.8 0 0 1 .394-.117c.068 0 .155.016.223.034a8.7 8.7 0 0 0 2.419.339c4.082 0 7.41-2.726 7.41-6.093 0-1.016-.309-1.98-.841-2.827l-8.522 4.857z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "weChatPay_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v20H0z"
  })))));
};
export default SvgWeChatPay;